module.exports = __webpack_public_path__ + "img/mcintosh-industries.e619f2f5.png";